import React from 'react';
import { useTranslation } from 'react-i18next';
import './OverlaySpinner.css';

function OverlaySpinner() {
  const { t } = useTranslation();
  
  return (
    <div className="overlay-spinner" role="status" aria-label={t('common.loading')}>
      <div className="overlay-spinner-circle" />
    </div>
  );
}

export default OverlaySpinner;
